export default "__VITE_ASSET__DsK_7fdT__"